<mat-toolbar class="main-bar mat-elevation-z1">
  <button
    mat-icon-button
    class="toolbar-icon"
    aria-label="Open Menu Drawer"
    (click)="openDrawer()"
  >
    <mat-icon>keyboard_double_arrow_right</mat-icon>
  </button>

  <button
    type="button"
    class="toolbar-logo-button"
    aria-label="Go to dashboard"
    (click)="onLogoClick()"
  >
    <img src="/assets/img/paacap-logo-toolbar.png" alt="PAACAP Logo" class="toolbar-logo" />
  </button>

  <span class="example-spacer"></span>

  <button
    mat-icon-button
    class="toolbar-icon"
    aria-label="Open Account"
    [matMenuTriggerFor]="menu"
  >
    <mat-icon>person</mat-icon>
  </button>

  <mat-menu #menu="matMenu" panelClass="account-menu">
    <div class="menu-header">
      <div class="account-details">
        <p class="account-name">{{ userData().name }}</p>
        <p class="account-role">{{ userData().role }}</p>
      </div>
    </div>
    <div class="menu-item">
      <button mat-button (click)="onLogout()">
        Logout
      </button>
    </div>
  </mat-menu>
</mat-toolbar>
